export { useGSAP, gsap, ScrollTrigger } from "./useGSAP";
